export const workflowTriggers = $axios => ({
  update: (workflowTriggerId, params) => $axios.$patch(`/workflow_triggers/${workflowTriggerId}`, params),
});
